import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Bangkok')

export const formatThaiDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return ''
  return dayjs
    .utc(date)
    .tz()
    .format(format)
}
